import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'lib/axios';

export const useCompany = (id: string): UseQueryResult<any[]> => {
	return useQuery({
		queryKey: ['company', id],
		queryFn: async() => {
			const { data: { company } } = await axios.get(`/companies/${id}`);
      return company;
		}
	});
};